import React from "react";

const SortUpIcon = () => (
    <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 0.5L1.5 12.5L6 8" stroke="#B7BDB9" strokeWidth="2" strokeLinejoin="round" />
    </svg>

)

export default SortUpIcon